import React, { Component } from "react";
import {Link} from "react-router-dom";
import { Auth } from "aws-amplify";
import Spacer from "../components/Spacer";
import * as prosConnect from "../prodect/ProsConnect";
import {isValidEmail, isValidCode} from "../prodect/ProsCommonUi";
import {prosNotificationShow} from "../prodect/ProsPopup";
import TextInput from "../components/TextInput";
import BasicButton from "../components/BasicButton";


export default class AuthContinueSignonWithCode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            email: prosConnect.getUserEmail(true) ? prosConnect.getUserEmail(true) : "",
            confirmationCode: "",
        };
    }

    validateForm() {
        return (
            this.state.email &&
            isValidEmail(this.state.email, true) &&
            this.state.confirmationCode &&
            isValidCode(this.state.confirmationCode)
        )
    }

    handleKeyDown =(evt)=> {
        if (evt.key === 'Enter'){
            evt.preventDefault()
            this.handleSubmit()
        }
    }

    handleChange = (id, val) => {
        this.setState({
            [id]: val
        })
    }

    handleSubmit = async ()=> {
        this.setState({ isLoading: true });
        try {
            await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
            this.props.history.push("/authLogin");
        } catch (e) {
            prosNotificationShow(this, e.message);
            this.setState({ isLoading: false });
        }
    };

    render() {
        return <>
            <div className="mini-page">
                <header>
                    <h1>Vahvista sähköpostiosoite saadulla koodilla</h1>
                </header>
                <section>
                    <form onSubmit={(evt)=>{
                        evt.preventDefault()
                        this.handleSubmit()
                    }}>
                        <TextInput
                            id={"email"}
                            type={"email"}
                            label={"Sähköposti"}
                            value={this.state.email}
                            onChange={(val)=> this.handleChange('email', val)}
                            placeholder={"Sähköpostiosoitteesi"}
                            autoFocus
                            required
                            isValid={isValidEmail(this.state.email, true)}
                            onKeyDown={this.handleKeyDown}
                        />
                        <TextInput
                            id={"confirmationCode"}
                            label={"Vahvistuskoodi"}
                            required
                            isValid={isValidCode(this.state.confirmationCode)}
                            autoFocus
                            type={"number"}
                            inputMode={"numeric"}
                            value={this.state.confirmationCode}
                            onChange={(val)=> this.handleChange('confirmationCode', val)}
                            placeholder={"Vahvistuskoodi"}
                            info={"Numerosarja sähköpostista"}
                            onKeyDown={this.handleKeyDown}
                        />
                        <div className={"btn-set_center"}>
                            <BasicButton
                                btnClass={"primary"}
                                label={this.state.isLoading ? "Tarkistetaan" : "tarkista"}
                                icon={this.validateForm() ? "check" : null}
                                buttonType={"submit"}
                                disabled={!this.validateForm()}
                                loading={this.state.isLoading}
                            />
                        </div>
                        <Spacer size={"lg"}/>
                        <div className={"msg"}>
                            <p>Vahvistuskoodi sähköpostista.
                            Jos et ole saanut koodia niin&nbsp;<Link to="/authSignup">rekisteröidy</Link>.
                            </p>
                        </div>
                    </form>
                </section>
            </div>
        </>
    }
}
